import React, { useState } from "react";
import { NavLink, useNavigate, useOutletContext } from "react-router-dom";
import { ArrowUpRight, BarChart3, BookOpen, ChevronRight, FileText, GraduationCap, LayoutDashboard, LogOut, Menu, Package, Palette, Tags, Users, X } from "lucide-react";
import "../admin.css";

const navItems = [
  { label: "Workspace", heading: true },
  { label: "Dashboard", href: "/admin", icon: LayoutDashboard },
  { label: "Onboarding Analytics", href: "/admin/onboarding-analytics", icon: BarChart3, ownerOnly: true },
  { label: "Personalisation", href: "/admin/personalisation", icon: Palette },
  { label: "Management", heading: true },
  { label: "Users", href: "/admin/user", icon: Users },
  { label: "Questions", href: "/admin/practice", icon: BookOpen },
  { label: "Posts", href: "/admin/post", icon: FileText },
  { label: "Commerce", heading: true },
  { label: "Products", href: "/admin/product", icon: Package },
  { label: "Dynamic Price", href: "/admin/product/price", icon: Tags },
];

export default function Sidebaradmin() {
  const navigate = useNavigate();
  const { role } = useOutletContext() || {};
  const [open, setOpen] = useState(false);
  const [logoutError, setLogoutError] = useState("");
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    setLogoutError("");
    try {
      const response = await fetch("/logout", { method: "GET", credentials: "include" });
      if (!response.ok) throw new Error("Unable to log out. Please try again.");
      navigate("/login");
    } catch (error) {
      setLogoutError(error.message);
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-brand">
        <div className="admin-brand-icon"><GraduationCap size={25} strokeWidth={1.8} /></div>
        <div><span className="admin-brand-name">PrepNexis<span>.</span></span><p>ADMIN CONSOLE</p></div>
        <button type="button" className="admin-mobile-toggle" aria-label={open ? "Close navigation" : "Open navigation"} aria-expanded={open} aria-controls="admin-navigation" onClick={() => setOpen(!open)}>
          {open ? <X size={21} /> : <Menu size={21} />}
        </button>
      </div>
      <div id="admin-navigation" className={`admin-sidebar-content ${open ? "is-open" : ""}`}>
        <nav aria-label="Admin navigation" className="admin-nav">
          {navItems.map((item) => {
            if (item.ownerOnly && Number(role) !== 1) return null;
            if (item.heading) return <p key={item.label} className="admin-nav-heading">{item.label}</p>;
            const Icon = item.icon;
            return (
              <NavLink key={item.href} to={item.href} end={item.href === "/admin" || item.href === "/admin/product"} onClick={() => setOpen(false)} className={({ isActive }) => `admin-nav-link ${isActive ? "is-active" : ""}`}>
                <Icon size={19} strokeWidth={1.7} /><span>{item.label}</span><ChevronRight size={14} className="admin-nav-arrow" aria-hidden="true" />
              </NavLink>
            );
          })}
        </nav>
        <div className="admin-sidebar-footer">
          <div className="admin-workspace-note"><span className="admin-status-dot" /><span>Your admin workspace</span></div>
          <NavLink to="/dashboard" className="admin-sidebar-utility"><GraduationCap size={18} /><span>User Dashboard</span><ArrowUpRight size={16} /></NavLink>
          <button type="button" className="admin-sidebar-utility" onClick={handleLogout} disabled={loggingOut}><LogOut size={18} /><span>{loggingOut ? "Logging out…" : "Logout"}</span></button>
          {logoutError && <p role="alert" className="admin-logout-error">{logoutError}</p>}
          <div className="admin-sidebar-profile"><span className="admin-avatar">AD</span><div><strong>Admin</strong><p>{Number(role) === 1 ? "Workspace owner" : "Administrator"}</p></div></div>
        </div>
      </div>
    </aside>
  );
}
